import { DnDItemTarget, DOCUMENT, LINKED, LINKED_DOCUMENT } from 'components/DnDItem';
import { alpha, styled, lighten } from '@mui/material/styles';
import ListItemButtonMui from '@mui/material/ListItemButton';
import ListItemMui from '@mui/material/ListItem';

export const DropTarget = DnDItemTarget([DOCUMENT, LINKED, LINKED_DOCUMENT]);

export const ListItem = styled(ListItemMui, { label: 'CategoryListItem' })(({ theme }) => ({
  padding: theme.spacing(0.5, 2),

  '& + &': {
    paddingTop: 0,
  },
}));

export const ListItemButton = styled(ListItemButtonMui, {
  shouldForwardProp: (propName) => !['level'].includes(propName),
})(({ theme, level }) => ({
  borderRadius: 8,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 400,
  marginLeft: theme.spacing(level === 2 ? 3.5 : 0),
  padding: theme.spacing(0.5, 1.5),

  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
  },

  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.common.white, 0.3),
    fontWeight: 500,

    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.1),
    },
  },

  '&.isDndOver': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.3),
  },

  '&.is-pending-approval': {
    backgroundColor: theme.palette.warning.light,

    '&:hover': {
      backgroundColor: lighten(theme.palette.warning.light, 0.15),
    },

    '&.Mui-selected': {
      backgroundColor: lighten(theme.palette.warning.light, 0.15),
    },
  },

  '&.is-publish-failed': {
    backgroundColor: theme.palette.error.light,

    '&:hover': {
      backgroundColor: lighten(theme.palette.error.light, 0.15),
    },

    '&.Mui-selected': {
      backgroundColor: lighten(theme.palette.error.light, 0.15),
    },
  },
}));

export const ListItemImage = styled('div', {
  shouldForwardProp: (propName) => !['src', 'isPendingApproval'].includes(propName),
})(({ src, theme }) => ({
  width: 20,
  minWidth: 20,
  height: 20,
  backgroundColor: theme.palette.common.white,
  WebkitMask: src !== null && src !== undefined ? `url(${src}) 0 0 no-repeat` : '',
  maskSize: 'contain',
}));
